module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-powered-b8852a7796d9001ef67e1dbbf0737d0a.svg";